module.exports = __webpack_public_path__ + "img/368x150_ecovadis.3f6c1777.jpg";